(function ($) {
  "use strict";
  $(function () {
    $(".callout__arrow").on("click", function () {
      $(this).hide();
      $(this).closest(".callout").find(".callout__gray-block").slideDown();
    });
  });
})(jQuery);
